// @ts-strict-ignore
import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';
import type {UserLocalStorageHelper} from 'common/report/user-local-storage';

import {DISMISS_KEY, PersistedDismissTooltipTour} from './types';

export function userDimissedTheCurrentTooltipTour(
  uniqueTourName,
  localStorageHelper: UserLocalStorageHelper<PersistedDismissTooltipTour>,
) {
  const dismissedTooltipTourNames = getCurrentTooltipTourList(localStorageHelper);
  return dismissedTooltipTourNames.includes(uniqueTourName);
}

export function getCurrentTooltipTourList(localStorageHelper: UserLocalStorageHelper<PersistedDismissTooltipTour>) {
  const dismissedTooltipTourNames = localStorageHelper?.getItem({
    key: DISMISS_KEY,
    userId: userCookieUtils.getUserIdentityFromCookie()?.id,
  });

  if (dismissedTooltipTourNames?.tips) {
    return dismissedTooltipTourNames.tips;
  } else {
    return [];
  }
}
